import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Phone, X } from "lucide-react";
import { api } from "@/lib/api";

const List = ({ title, rows, testid, render }) => rows.length > 0 && (
  <div data-testid={testid}>
    <div className="text-xs font-bold text-slate-700 mb-1">{title} ({rows.length})</div>
    <div className="space-y-1">{rows.map(render)}</div>
  </div>
);

export const PhoneSyncModal = ({ onClose, onDone }) => {
  const [plan, setPlan] = useState(null);
  const [choice, setChoice] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/payroll/meal-cards/phone-sync").then((r) => setPlan(r.data)).catch(() => { toast.error("Yüklenemedi"); onClose(); }); }, []); // eslint-disable-line

  const apply = async () => {
    setBusy(true);
    try {
      const r = await api.post("/payroll/meal-cards/phone-sync", { choices: choice });
      toast.success(`${r.data.cards_updated} kart, ${r.data.personnel_updated} personel güncellendi${r.data.skipped ? ` · ${r.data.skipped} atlandı` : ""}`);
      onDone?.(); onClose();
    } catch { toast.error("Eşitlenemedi"); } finally { setBusy(false); }
  };
  const total = plan ? plan.to_card.length + plan.to_person.length + plan.conflicts.length : 0;
  const row = (r, txt) => (
    <div key={r.card_id} className="text-xs bg-slate-50 border border-slate-200 rounded px-2 py-1"><strong>{r.ad_soyad}</strong> · {r.kart_no} · {txt}</div>
  );

  return (
    <div className="fixed inset-0 z-[80] bg-black/50 flex items-center justify-center p-4" data-testid="phone-sync-modal">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col">
        <div className="p-3 border-b flex items-center justify-between">
          <div className="text-sm font-bold text-slate-900 flex items-center gap-1.5"><Phone size={14} /> Kart Telefon Eşitleme</div>
          <button onClick={onClose} data-testid="phone-sync-close" className="w-7 h-7 rounded-lg hover:bg-slate-100 grid place-items-center"><X size={14} /></button>
        </div>
        <div className="p-3 overflow-y-auto space-y-3">
          {!plan ? <div className="text-center py-6"><Loader2 size={16} className="inline animate-spin" /></div> : total === 0 ? (
            <div className="text-sm text-emerald-700 text-center py-6" data-testid="phone-sync-ok">Tüm kart ve personel telefonları eşit.</div>
          ) : (
            <>
              <List title="Karta personel kaydından yazılacak" rows={plan.to_card} testid="phone-sync-to-card" render={(r) => row(r, `cep: ${r.personel_tel}`)} />
              <List title="Personel kaydına karttan yazılacak" rows={plan.to_person} testid="phone-sync-to-person" render={(r) => row(r, `telefon: ${r.kart_tel}`)} />
              <List title="Farklı numaralar · hangisi kullanılsın?" rows={plan.conflicts} testid="phone-sync-conflicts" render={(r) => (
                <div key={r.card_id} className="text-xs bg-amber-50 border border-amber-300 rounded px-2 py-1.5" data-testid={`phone-conflict-${r.kart_no}`}>
                  <div className="font-semibold mb-1">{r.ad_soyad} · kart {r.kart_no}</div>
                  <div className="flex flex-wrap gap-3">
                    {[["personel", `Personel kaydı: ${r.personel_tel}`], ["kart", `Kart: ${r.kart_tel}`], ["", "Atla"]].map(([v, l]) => (
                      <label key={v || "skip"} className="inline-flex items-center gap-1 cursor-pointer">
                        <input type="radio" name={`ps-${r.card_id}`} checked={(choice[r.card_id] || "") === v} data-testid={`phone-conflict-${r.kart_no}-${v || "skip"}`}
                          onChange={() => setChoice({ ...choice, [r.card_id]: v })} /> {l}
                      </label>
                    ))}
                  </div>
                </div>
              )} />
            </>
          )}
        </div>
        <div className="p-3 border-t flex justify-end gap-2 bg-slate-50 rounded-b-xl">
          <button onClick={onClose} className="px-3 py-1.5 border border-slate-300 rounded-lg text-sm font-semibold">Kapat</button>
          {total > 0 && (
            <button onClick={apply} disabled={busy} data-testid="phone-sync-apply"
              className="px-3 py-1.5 bg-teal-700 hover:bg-teal-800 text-white rounded-lg text-sm font-semibold disabled:opacity-50">
              {busy ? <Loader2 size={14} className="inline animate-spin" /> : "Eşitle"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
